import React, { Component } from 'react';
import logo from './logo.jpg';
import './App.css';
import {Link, Route} from 'react-router-dom';
import GroupPage from "./grouppage.js"
import AboutPage from "./aboutpage.js"

//----------------------------------------------------------------
class App extends Component {

// ---------------------- App / render ----------------------------
  render() {
    //console.log('imageList:'+ this.state.imageList)
    return (
      <div className="App">
          <div className="App-header">
            <img src={logo} align="left" className="App-logo" alt="logo" />
            <h2 align="center">Kuvassa.si</h2>
            <dl align="right" className="nav navbar-nav">
              <dt><Link to="/">home</Link></dt>
              <dt><Link to="/about">about</Link></dt>
            </dl>
          </div>
        <div>
          <Route exact path='/group' component={GroupPage}></Route>
          <Route exact path='/about' component={AboutPage}></Route>
        </div>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js